import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/avatars/avatar-1.jpg'
import _imports_1 from '@/assets/author.png'


const _withScopeId = n => (_pushScopeId("data-v-26a07add"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = { class: "content-tooltip" }
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 89 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 128 ", -1))
const _hoisted_9 = { style: {"font-weight":"bolder","padding":"6px"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-heart" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bx bx-like" }, null, -1))
const _hoisted_12 = {
  class: "market-content",
  id: "padding-scroll-content"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "market-footer-left" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "market-footer-title" }, "关于我们"),
  /*#__PURE__*/_createElementVNode("p", null, "一个不正经的科技公司")
], -1))
const _hoisted_14 = { class: "market-footer-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "market-footer-title" }, "创始人", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "boss"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"market-footer-center\" data-v-26a07add><p class=\"market-footer-title\" data-v-26a07add>产品理念</p><p data-v-26a07add>更符合现代的数字交易</p></div><div class=\"market-footer-center\" data-v-26a07add><p class=\"market-footer-title\" data-v-26a07add>最新动态</p><p data-v-26a07add>有个锤子</p></div><div class=\"market-footer-right\" data-v-26a07add><p class=\"market-footer-title\" data-v-26a07add>服务相关</p><p data-v-26a07add>买了么卖了么贷了么</p></div><div class=\"market-footer-bottom\" data-v-26a07add><p style=\"display:flex;\" data-v-26a07add> 湖南省湘潭市雨湖区昭潭乡韶山西路389号新金都商业广场1401003-A14387号   |   <img src=\"https://thatcoder.cn/img/beianIcon.png\" width=\"20px\" height=\"20px\" data-v-26a07add><a target=\"_blank\" href=\"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43030202001297\" data-v-26a07add> 湘公网安备 43030202001297号</a>   |   <a href=\"https://beian.miit.gov.cn/\" target=\"_blank\" data-v-26a07add>湘ICP备2023019799号-1</a></p></div>", 4)
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"font-size":"20px","font-weight":"bolder"} }, "菜单", -1))
const _hoisted_22 = { class: "con-content-scroll" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "not-margin" }, [
  /*#__PURE__*/_createTextVNode("Welcome to "),
  /*#__PURE__*/_createElementVNode("b", null, "Art Stack")
], -1))
const _hoisted_24 = { class: "con-form" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-lock" }, null, -1))
const _hoisted_26 = { class: "flex" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Forgot Password?", -1))
const _hoisted_28 = { class: "footer-dialog" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "new" }, [
  /*#__PURE__*/_createTextVNode("New Here? "),
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Create New Account")
], -1))

import { ref } from "vue";
import TcVsButton1 from "@/components/vueSax/TcVsButton1.vue";
import TcVsSidebar from "@/components/vueSax/TcVsSidebar.vue";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {
  VsAvatar,
  VsAvatarGroup,
  VsButton,
  VsCheckbox,
  VsIcon,
  VsInput,
  VsDialog,
  VsNavbar,
  VsNavbarItem,
  VsTooltip,
} from "vuesax-alpha";

// 夜间模式仓
import { useDark, useToggle } from "@vueuse/core";
import MsgServer from "@/utils/MsgServer";
import CommonTool from "../utils/CommonTools";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

// iconfont: //at.alicdn.com/t/c/font_4240721_y82hcipl5cf.js
const isDark = useDark();
const toggleDark = () => {
  const toggleDark2 = useToggle(isDark);
  toggleDark2();
  // openNotification("top-center", "warn");
};

// 可见性控制仓
const visitDialogAvatar = ref(false);
const visitDialogLogin = ref(false);

// 属性变更仓
const activeTooltip1 = ref(false);

// 数据仓
const conFormValue = ref({
  email: "",
  password: "",
  rm: false,
});

// 菜单数据
let navbarMenuActive = ref(window.location.pathname.split("/")[1]);
let sidebarMenuActive = ref("user");
let sidebarMenuData = ref({
  menu: [
    {
      id: "user",
      path: "/user",
      title: "index-sidebar-item-user",
      icon: "bx bxs-user",
    },
    {
      id: "demands",
      title: "index-sidebar-item-demand",
      icon: "bx bxs-box",
      children: [
        {
          id: "demanderAdd",
          path: "/demander/add",
          title: "index-sidebar-item-demand-add",
          icon: "bx bx-add-to-queue",
        },
        {
          id: "demanderList",
          path: "/demander/list",
          title: "index-sidebar-item-demand-list",
          icon: "bx bx-list-ul",
        },
        {
          id: "demanderArb",
          path: "/demander/arbitration",
          title: "index-sidebar-item-demand-help",
          icon: "bx bxs-check-shield",
        },
      ],
    },
    {
      id: "developer",
      title: "index-sidebar-item-develop",
      icon: "bx bxs-terminal",
      children: [
        {
          id: "developerAdd",
          path: "/developer/add",
          title: "index-sidebar-item-develop-demandList",
          icon: "bx bx-list-check",
        },
        {
          id: "developerList",
          path: "/developer/list",
          title: "index-sidebar-item-develop-artList",
          icon: "bx bxs-spa",
        },
        {
          id: "developerArb",
          path: "/developer/arbitration",
          title: "index-sidebar-item-develop-help",
          icon: "bx bxs-check-shield",
        },
      ],
    },
  ],
});
//载入执行

return (_ctx: any,_cache: any) => {
  const _component_vsIconHeartBold = _resolveComponent("vsIconHeartBold")!
  const _component_vsIconBoxBold = _resolveComponent("vsIconBoxBold")!
  const _component_vsIconTerminalBold = _resolveComponent("vsIconTerminalBold")!
  const _component_vsIconAlarmBold = _resolveComponent("vsIconAlarmBold")!
  const _component_vsIconBell = _resolveComponent("vsIconBell")!
  const _component_vsIconCommand = _resolveComponent("vsIconCommand")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["center page-market", _unref(isDark) ? 'page-navbar-dark' : 'page-navbar-light'])
    }, [
      _createVNode(_unref(VsNavbar), {
        square: "",
        modelValue: _unref(navbarMenuActive),
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(navbarMenuActive) ? (navbarMenuActive).value = $event : navbarMenuActive = $event)),
        class: _normalizeClass(_unref(isDark) ? 'header-navbar-dark' : 'header-navbar'),
        "target-scroll": "#padding-scroll-content",
        "left-collapsed": "",
        "right-collapsed": ""
      }, {
        left: _withCtx(() => [
          _createElementVNode("i", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (visitDialogLogin.value = !visitDialogLogin.value)),
            class: "bx bxl-apple",
            style: _normalizeStyle({
            color: !_unref(isDark) ? 'rgba(5, 5, 5, 0.76)' : 'rgb(238,233,233)',
            fontSize: '48px',
          })
          }, null, 4),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("index-navbar-info")), 1)
        ]),
        right: _withCtx(() => [
          _createVNode(_unref(VsTooltip), {
            type: "shadow",
            interactivity: ""
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createTextVNode(_toDisplayString(_ctx.$t("index-sidebar-item-develop-demandList")) + " ", 1),
                    _hoisted_5
                  ]),
                  _createVNode(_unref(VsAvatar), {
                    shape: "circle",
                    size: "80",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (activeTooltip1.value = !activeTooltip1.value))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t("index-sidebar-item-develop-artList")) + " ", 1),
                    _hoisted_8
                  ])
                ]),
                _createElementVNode("h1", _hoisted_9, _toDisplayString(_unref(CommonTool).getItem("tokenInfo")["iss"] ||
                  _ctx.$t("common-login-default")), 1),
                _createElementVNode("footer", null, [
                  _createVNode(_unref(VsButton), {
                    color: "danger",
                    shape: "circle",
                    icon: "",
                    type: "border"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(VsButton), {
                    color: "danger",
                    shape: "circle"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("index-sidebar-item-user")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(VsButton), {
                    color: "danger",
                    shape: "circle",
                    icon: "",
                    type: "border"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(VsAvatar), {
                class: "header-navbar-button",
                size: "40",
                badge: "",
                "badge-color": "discord",
                history: "",
                "history-gradient": "",
                shape: "circle"
              }, {
                badge: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("common-user-status")), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(VsAvatar), {
            size: "40",
            class: "header-navbar-button",
            modelValue: _ctx.$i18n.locale,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$i18n.locale = _ctx.$i18n.locale === 'zh' ? 'en' : 'zh'))
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                style: {"color":"goldenrod"},
                class: _normalizeClass(
              _ctx.$i18n.locale === 'en' ? 'bx bxs-dollar-circle' : 'bx bx-yen'
            )
              }, null, 2)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_unref(VsAvatar), {
            size: "40",
            class: "header-navbar-button",
            modelValue: _unref(isDark),
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(isDark) ? (isDark).value = $event : null)),
            onClick: _cache[10] || (_cache[10] = ($event: any) => (toggleDark()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                style: {"color":"goldenrod"},
                class: _normalizeClass(_unref(isDark) ? 'bx bxs-sun' : 'bx bxs-moon')
              }, null, 2)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_unref(VsAvatar), {
            size: "40",
            class: "header-navbar-button",
            "badge-color": "danger",
            "badge-position": "top-right"
          }, {
            badge: _withCtx(() => [
              _createTextVNode(" 8 ")
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(VsIcon), null, {
                default: _withCtx(() => [
                  _createVNode(_component_vsIconBell)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(VsAvatar), {
            size: "40",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (visitDialogAvatar.value = !visitDialogAvatar.value)),
            class: "header-navbar-button",
            "badge-color": "danger",
            "badge-position": "top-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VsIcon), null, {
                default: _withCtx(() => [
                  _createVNode(_component_vsIconCommand)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(VsNavbarItem), {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(navbarMenuActive) //@ts-ignore
 ? navbarMenuActive.value = 'index' : navbarMenuActive = 'index')),
            active: _unref(navbarMenuActive) === 'index',
            to: "/"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VsIcon), {
                style: _normalizeStyle({ background: 'var(--vs-danger)' })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_vsIconHeartBold)
                ]),
                _: 1
              }, 8, ["style"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("index-navbar-item-index")), 1)
            ]),
            _: 1
          }, 8, ["active"]),
          _createVNode(_unref(VsNavbarItem), {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(navbarMenuActive) //@ts-ignore
 ? navbarMenuActive.value = 'market' : navbarMenuActive = 'market')),
            active: _unref(navbarMenuActive) === 'market',
            to: "/market"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VsIcon), null, {
                default: _withCtx(() => [
                  _createVNode(_component_vsIconBoxBold)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("index-navbar-item-market")), 1)
            ]),
            _: 1
          }, 8, ["active"]),
          _createVNode(_unref(VsNavbarItem), {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_isRef(navbarMenuActive) //@ts-ignore
 ? navbarMenuActive.value = 'dream' : navbarMenuActive = 'dream')),
            active: _unref(navbarMenuActive) === 'dream',
            link: { path: '/market', text: '艺术市场' }
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VsIcon), null, {
                default: _withCtx(() => [
                  _createVNode(_component_vsIconTerminalBold)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("index-navbar-item-demand")), 1)
            ]),
            _: 1
          }, 8, ["active"]),
          _createVNode(_unref(VsNavbarItem), {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_isRef(navbarMenuActive) //@ts-ignore
 ? navbarMenuActive.value = 'discuss' : navbarMenuActive = 'discuss')),
            active: _unref(navbarMenuActive) === 'discuss'
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VsIcon), null, {
                default: _withCtx(() => [
                  _createVNode(_component_vsIconAlarmBold)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("index-navbar-item-chat")), 1)
            ]),
            _: 1
          }, 8, ["active"]),
          _createVNode(_unref(VsNavbarItem), {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_isRef(navbarMenuActive) //@ts-ignore
 ? navbarMenuActive.value = 'exhibition' : navbarMenuActive = 'exhibition')),
            active: _unref(navbarMenuActive) === 'exhibition',
            id: "license"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VsIcon), {
                style: _normalizeStyle({ background: 'var(--vs-danger)' })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_vsIconHeartBold)
                ]),
                _: 1
              }, 8, ["style"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("index-navbar-item-show")), 1)
            ]),
            _: 1
          }, 8, ["active"])
        ]),
        _: 1
      }, 8, ["modelValue", "class"]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_router_view),
        _createElementVNode("footer", {
          class: "market-footer",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(MsgServer).chat()))
        }, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_unref(VsAvatarGroup), { max: "5" }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (index) => {
                  return _createVNode(_unref(VsAvatar), { key: index }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            })
          ]),
          _hoisted_17
        ])
      ]),
      (!['index', ''].includes(_unref(navbarMenuActive)))
        ? (_openBlock(), _createBlock(TcVsSidebar, {
            key: 0,
            sidebarData: _unref(sidebarMenuData),
            "sidebar-active": _unref(sidebarMenuActive)
          }, null, 8, ["sidebarData", "sidebar-active"]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_unref(VsDialog), {
      modelValue: visitDialogAvatar.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((visitDialogAvatar).value = $event)),
      scroll: "",
      "lock-scroll": "",
      "not-close": "",
      "auto-width": "",
      "overlay-blur": ""
    }, {
      header: _withCtx(() => [
        _hoisted_21
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(TcVsButton1, {
            icon: "bxs-moon",
            title: "主题设置",
            content: "按喜好订制页面",
            color: "discord",
            width: "168",
            height: "80"
          }),
          _createVNode(TcVsButton1, {
            icon: "bxs-moon",
            title: "主题",
            content: "按喜好订制页面",
            color: "discord",
            width: "168",
            height: "80"
          }),
          _createVNode(TcVsButton1, {
            icon: "bxs-moon",
            title: "主题",
            content: "按喜好订制页面",
            color: "discord",
            width: "168",
            height: "80"
          }),
          _createVNode(TcVsButton1, {
            icon: "bxs-moon",
            title: "主题",
            content: "按喜好订制页面",
            color: "discord",
            width: "168",
            height: "80"
          }),
          _createVNode(TcVsButton1, {
            icon: "bxs-moon",
            title: "主题",
            content: "按喜好订制页面",
            color: "discord",
            width: "168",
            height: "80"
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(VsDialog), {
      modelValue: visitDialogLogin.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((visitDialogLogin).value = $event)),
      "overlay-blur": ""
    }, {
      header: _withCtx(() => [
        _hoisted_23
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_unref(VsButton), { block: "" }, {
            default: _withCtx(() => [
              _createTextVNode(" Sign In ")
            ]),
            _: 1
          }),
          _hoisted_29
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_unref(VsInput), {
            modelValue: conFormValue.value.email,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((conFormValue.value.email) = $event)),
            placeholder: "Email"
          }, {
            icon: _withCtx(() => [
              _createTextVNode(" @ ")
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_unref(VsInput), {
            modelValue: conFormValue.value.password,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((conFormValue.value.password) = $event)),
            type: "password",
            placeholder: "Password"
          }, {
            icon: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_unref(VsCheckbox), {
              modelValue: conFormValue.value.rm,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((conFormValue.value.rm) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Remember me")
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_27
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})